import * as React from 'react';
import { InlineText3 } from '@cian/ui-kit/typography';
import classNames from 'classnames';

import * as styles from './styles.css';

export interface IEscrowLabelProps {
  blue?: boolean;
  dark?: boolean;
  onClick?(event: React.MouseEvent<HTMLElement>): void;
}

export function EscrowLabel({ onClick, blue, dark }: IEscrowLabelProps) {
  return (
    <div
      className={classNames(
        styles['container'],
        styles['escrow'],
        blue && styles['escrow-blue'],
        dark && styles['escrow-dark'],
      )}
      onClick={onClick}
    >
      <InlineText3 color={blue ? 'primary_100' : 'black_100'}>Эскроу</InlineText3>
    </div>
  );
}
